import { render } from "./LinkifiedText.vue?vue&type=template&id=23fce658"
import script from "./LinkifiedText.vue?vue&type=script&lang=js"
export * from "./LinkifiedText.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__